import React from "react";

const Loader = () => {
  return (
    <div id="preloader">
      <div className="loader3">
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default Loader;
